import React from 'react';
import {Typography,} from '@mui/material';
import './CorporateRisk.css';
import TextCard from "./TextCard";

const CorporateResilienceSummary = (company, isLoading) => {
    const corporateExposure = corporateExposureParser(company);
    return (
        <div id="content" className={"bg-black"}
             style={{
                 width: '100%', margin: "10px auto 0 auto", padding: "0 15px", fontSize: "1rem", fontWeight: "500",
                 lineHeight: "1.5", height: "20%"
             }}>
            {isLoading && (<Typography variant="h5" className="gray-text">Loading...</Typography>)}
            {!isLoading && (corporateExposure)}
        </div>
    );
}

const corporateExposureParser = (company) => {
    return (
        <>
            <table className={"table table-dark"} style={{backgroundColor: "black"}}>
                <tbody>
                <tr>
                    <td width={'25%'} style={{verticalAlign: "middle"}}>
                        <Typography variant="h4" className="gray-text">Resilience Summary</Typography>
                    </td>
                    <td width={'75%'}>
                        <TextCard content={`${company.resilience_summary}`}/>
                    </td>
                </tr>
                {
                    company.categories.map(
                        (category, index) => {
                            return (
                                <tr>
                                    <td width={'25%'} style={{verticalAlign: "middle"}}>
                                        <Typography variant="h5" className="gray-text">{`${category.category_name} - Score ${category.score}/${category.max_score}`}</Typography>
                                    </td>
                                    <td width={'75%'}>
                                        <TextCard content={`${category.synthesis}`}/>
                                    </td>
                                </tr>
                            )
                        }
                    )
                }
                </tbody>
            </table>
        </>
    )
}

export default CorporateResilienceSummary;
